import { RangeSelect } from "./RangeSelect";
import { Share } from "./Share";

export default function ChartFilter({ headline, shareable }) {
  return (
    <div className="flex mb-6 flex-col gap-3">
      <div className="flex items-center justify-between gap-3">
        <RangeSelect />
        <Share headline={headline} shareable={shareable} />
      </div>
    </div>
  );
}
